// use postfield
import React from 'react';

import TextParseComponent from 'components/feed/TextParseComponent';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

const CustomStyledTypography = styled(StyledTypography)`
  width: 100%;
  text-decoration: ${(props) => (props.isCompleted ? 'line-through' : 'none')};
  text-decoration-color: #555;
  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-top: 5px;
  }
`;

export default function TaskOrGoalName({ text, macros, isCompleted = false, ...props }) {
  return (
    <CustomStyledTypography
      variant="body2"
      display="inline"
      topGutter={0.8}
      rightGutter={2}
      isCompleted={isCompleted}
      {...props}
    >
      <TextParseComponent text={text} res={macros} />
    </CustomStyledTypography>
  );
}
